import { useEffect, useState } from "react";
import { localUserProfileInteractor } from "di";
import { UserProfile } from "core";

import GenericCard from "components/UI/GenericCard/GenericCard";

type Props = {
  onClick?: () => void;
  className?: string;
};

export default function AllAboutYou({ onClick, className }: Props) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        if (localUserProfileInteractor.existsUserProfile()) {
          const userProfile =
            localUserProfileInteractor.getUserProfile() as UserProfile;
          setProgress(userProfile.allAboutYouPercentage);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div
      className={className}
      onClick={() => onClick}
      style={{ width: "100%", height: "100%" }}
    >
      <GenericCard
        title="All about you"
        subtitle="Queremos saber sobre vos! Completá este formulario y ayudanos a tener todo listo para recibirte!"
        color="violet"
        progress={progress}
      />
    </div>
  );
}
